"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var addresses_1 = __importDefault(require("./addresses"));

var base_1 = __importDefault(require("./base"));

var payment_methods_1 = __importDefault(require("./payment-methods"));

var CustomerResource =
/** @class */
function (_super) {
  __extends(CustomerResource, _super);

  function CustomerResource() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.paymentMethods = new payment_methods_1.default(_this.client);
    _this.addresses = new addresses_1.default(_this.client);
    return _this;
  }
  /**
   * Creates a customer
   * @param {StorePostCustomersReq} payload information of customer
   * @return { ResponsePromise<StoreCustomersRes>}
   */


  CustomerResource.prototype.create = function (payload) {
    var path = "/store/customers";
    return this.client.request("POST", path, payload);
  };
  /**
   * Retrieves the customer that is currently logged
   * @return {ResponsePromise<StoreCustomersRes>}
   */


  CustomerResource.prototype.retrieve = function () {
    var path = "/store/customers/me";
    return this.client.request("GET", path);
  };
  /**
   * Updates a customer
   * @param {StorePostCustomersCustomerReq} payload information to update customer with
   * @return {ResponsePromise<StoreCustomersRes>}
   */


  CustomerResource.prototype.update = function (payload) {
    var path = "/store/customers/me";
    return this.client.request("POST", path, payload);
  };
  /**
   * Retrieve customer orders
   * @param {StoreGetCustomersCustomerOrdersParams} params optional params to retrieve orders
   * @return {ResponsePromise<StoreCustomersListOrdersRes>}
   */


  CustomerResource.prototype.listOrders = function (params) {
    var path = "/store/customers/me/orders";

    if (params) {
      var query = void 0;

      for (var _i = 0, _a = Object.keys(params); _i < _a.length; _i++) {
        var key = _a[_i];

        if (query) {
          query += "&" + key + "=" + params[key];
        } else {
          query = "?" + key + "=" + params[key];
        }
      }

      if (query) {
        path += query;
      }
    }

    return this.client.request("GET", path);
  };
  /**
   * Resets customer password
   * @param {StorePostCustomersCustomerPasswordTokenReq} payload info used to reset customer password
   * @return {ResponsePromise<StoreCustomersRes>}
   */


  CustomerResource.prototype.resetPassword = function (payload) {
    var path = "/store/customers/password-reset";
    return this.client.request("POST", path, payload);
  };
  /**
   * Generates a reset password token, which can be used to reset the password.
   * The token is not returned but should be sent out to the customer in an email.
   * @param {StorePostCustomersCustomerPasswordTokenReq} payload info used to generate token
   * @return {ResponsePromise}
   */


  CustomerResource.prototype.generatePasswordToken = function (payload) {
    var path = "/store/customers/password-token";
    return this.client.request("POST", path, payload);
  };

  return CustomerResource;
}(base_1.default);

exports.default = CustomerResource;